module.exports = __webpack_public_path__ + "img/delete-icon.c918c892.svg";